// A designer shortcut acts on what is behind the dialogs: Delete removes the selected
// element, Ctrl+Z undoes the last canvas change, Alt+1..9 jumps to another tool. None of
// that may fire while the user is working inside a MODAL overlay, because the thing it
// would act on is out of sight and the user has no reason to think they are touching it.
//
// These listeners used to test `closest(".ant-modal")`. The designer's modals have been
// `KModal` (rc-dialog under the `k-modal` prefix) since the antd Modal was retired, so that
// test matched nothing and the shortcuts fired straight through an open dialog.
//
// Modal, not "any dialog": a Radix popover also carries `role="dialog"`, but it is
// non-modal — someone adjusting a colour in a popover still expects Ctrl+Z to undo it. So
// the test is the modal contract, not the role:
// - `[aria-modal='true']` is what rc-dialog puts on a KModal panel, and what any future
//   modal is expected to declare.
// - `.k-modal` names the KModal panel directly, so an rc-dialog upgrade that moved the
//   attribute would not silently reopen this.
// - `.kuika-drawer` is the kit drawer. It is modal (focus trap, inert page behind it) but
//   built on Radix Dialog, which does not emit `aria-modal`.
export const MODAL_OVERLAY_SELECTOR: string = "[aria-modal='true'], .k-modal, .kuika-drawer";

/** True when a keyboard event's target sits inside a modal overlay the designer renders. */
export const isInsideModalOverlay = (target: EventTarget | null): boolean => {
  return target instanceof Element && target.closest(MODAL_OVERLAY_SELECTOR) !== null;
};
